<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="cubes"></font-awesome-icon>
            <a  class="mainblock-label">专题视频</a>
          </div>
        </div>
        <div class="container-body">
          <ul class="panel-course" >
            <li v-for="topic in topicList">
              <a target="_blank" class="card-course" @click="toVideoDetail(topic.dataId)">
                <div class="card-course-top">
                  <img :src="url+topic.coverUrl"/>
                </div>
                <div class="card-course-name">{{topic.title}}</div>
              </a>
            </li>

          </ul>
        </div>
      </div>
    </div>


  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters } from 'vuex'
  export default {
    name: 'Training',
    inject:['check','changeActiveIndex'],
    data(){
      return {
        topicId: '',
        topicList: [],
        //url:'http://121.89.210.255:8080/jinneng/'
        //url:'https://www.jnjtzxpx.com/jinneng/'
        url:'https://www.jnjtzxpx.com/jinnengApi/',

      }
    },
    mounted() {
      this.topicId = this.$route.query.topicId
      this.findAllData()
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    methods:{
      findAllData(){
        let url = '/api/videoNews/findVideoByTopic'
        let that = this
        let params = {
          topicId: this.topicId
        }
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.topicList = res.data
        }))
      },
      toVideoDetail(newsId){

        let user = this.user
        if (user== null){
          this.check()
        }else {
          this.$router.push({
            path:'/VideoDetail',
            query:{
              videoNewsId:newsId
            }
          })
        }

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/TopicVideoList.vue